import { render, staticRenderFns } from "./productEditPrice.vue?vue&type=template&id=9bbebc12&scoped=true"
import script from "./productEditPrice.vue?vue&type=script&lang=js"
export * from "./productEditPrice.vue?vue&type=script&lang=js"
import style0 from "./productEditPrice.vue?vue&type=style&index=0&id=9bbebc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbebc12",
  null
  
)

export default component.exports